import React from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./ListaAlunos.css";


const Paginacao = ({ paginaAtual, totalPaginas, setPaginaAtual }) => {
  return (
    <div className="paginacao">
      {paginaAtual > 1 && (
        <FaArrowLeft onClick={() => setPaginaAtual(paginaAtual - 1)} />
      )}
      <span>{paginaAtual}</span>
      {paginaAtual < totalPaginas && (
        <FaArrowRight onClick={() => setPaginaAtual(paginaAtual + 1)} />
      )}
    </div>
  );
};

export default Paginacao;
